import React, {useMemo} from 'react';
import {Box, Typography} from '@mui/material';
import {VictoryAnimation, VictoryLabel, VictoryPie} from 'victory';
import {getLoadValueColor} from '../../../services/graphService';
import {ACWR_MAX} from '../../../constants';
import {DefaultTFuncReturn} from 'i18next';

const DEFAULT_SIZE = 150;

interface Props {
  acwr: number;
  // Rendered svg size in px.
  size?: number;
  label?: string | DefaultTFuncReturn;
  labelSmall?: string | DefaultTFuncReturn;
}

const PlayerACWRGasGauge: React.FC<Props> = ({
  acwr,
  size = DEFAULT_SIZE,
  label,
  labelSmall,
}) => {
  const acwrDisplay = useMemo(() => {
    if (acwr >= ACWR_MAX) {
      return ACWR_MAX;
    }
    return acwr;
  }, [acwr]);

  const getData = (acwr: number) => {
    return [
      {x: 1, y: acwr},
      {x: 2, y: ACWR_MAX - acwr},
    ];
  };

  return (
    <Box>
      <svg viewBox="0 0 400 400" width={size} height={size}>
        <VictoryPie
          standalone={false}
          animate={{duration: 1000}}
          startAngle={-180}
          endAngle={130}
          width={400}
          height={400}
          data={getData(acwrDisplay)}
          innerRadius={120}
          cornerRadius={25}
          labels={() => null}
          style={{
            data: {
              fill: ({datum}) => {
                const color = getLoadValueColor(datum.y);
                return datum.x === 1 ? color : '#fff';
              },
            },
          }}
        />
        <VictoryAnimation duration={1000} data={getData(acwrDisplay)}>
          {() => {
            return (
              <VictoryLabel
                textAnchor="middle"
                verticalAnchor="middle"
                x={200}
                y={200}
                text={(acwrDisplay ?? 0).toFixed(1)}
                style={{
                  fontSize: 100,
                  fill: '#fff',
                  fontWeight: 700,
                  fontFamily: 'Roboto Condensed',
                }}
              />
            );
          }}
        </VictoryAnimation>
      </svg>
      {label && (
        <Typography variant="h3" sx={{textAlign: 'center'}}>
          {label}
        </Typography>
      )}
      {labelSmall && (
        <Typography variant="h4" sx={{textAlign: 'center'}}>
          {labelSmall}
        </Typography>
      )}
    </Box>
  );
};

export default PlayerACWRGasGauge;
